import { NgModule } from '@angular/core'

import {
  MdButtonModule,
  MdIconModule,
  MdMenuModule,
  MdSlideToggleModule,
  MdRadioModule,
  MdInputModule,
  MdCardModule,
  MdToolbarModule,
  MdTooltipModule,
  MdListModule,
  MdSliderModule,
  MdDialogModule,
  MdSnackBarModule
} from '@angular/material'

@NgModule({
  imports: [
    MdButtonModule,
    MdIconModule,
    MdMenuModule,
    MdSlideToggleModule,
    MdRadioModule,
    MdInputModule,
    MdCardModule,
    MdToolbarModule,
    MdTooltipModule,
    MdListModule,
    MdSliderModule,
    MdDialogModule,
    MdSnackBarModule
  ],
  exports: [
    MdButtonModule,
    MdIconModule,
    MdMenuModule,
    MdSlideToggleModule,
    MdRadioModule,
    MdInputModule,
    MdCardModule,
    MdToolbarModule,
    MdTooltipModule,
    MdListModule,
    MdSliderModule,
    MdDialogModule,
    MdSnackBarModule
  ]
})
export class MaterialModule { }



// WEBPACK FOOTER //
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/material/material.module.ts